// Set document.title for the active route. Each screen calls this with its
// brand-voice title; the unmount cleanup restores the default so the tab
// title doesn't drift. The suffix comes from the tenant branding config
// (useBranding hook), so a tenant like LDF-POC will read " · CFL" instead
// of " · InCorpoSano" without touching this file.

import { useEffect } from "react";

import { useBranding } from "@/lib/branding";

export function useScreenTitle(title: string): void {
  const { pageTitleSuffix } = useBranding();
  useEffect(() => {
    const previous = document.title;
    document.title = title + pageTitleSuffix;
    return () => {
      document.title = previous;
    };
  }, [title, pageTitleSuffix]);
}
